import SortByFilter from './../FilterList/Filters/SortByFilter/SortByFilter';
import ProductViewSwitcher from './ProductViewSwitcher/ProductViewSwitcher';
import ResultCount from './ResultCount/ResultCount';
import { productsResultCount } from '../../../Atoms/ProductAtoms';
import { useAtom } from 'jotai';
import ActiveFilterItems from './ActiveFilterItems/ActiveFilterItems';
import styles from './ProductToolbar.module.scss?module';
import { useProductsFilter } from '../../../Context/ProductsFilterContext';
import { useUser } from '../../../Context/UserContext';

type ProductToolbarProps = {
  isMobile: boolean;
  additionalFilters?: { key: string; value: string }[];
};

const ProductToolbar = ({
  isMobile,
  additionalFilters,
}: ProductToolbarProps) => {
  const { filters } = useProductsFilter();
  const [resultCount, setResultCount] = useAtom(productsResultCount);
  const { user } = useUser();

  return (
    <div className={styles.ProductToolbarContainer}>
      <div className={styles.HeaderRow}>
        <div className="d-flex align-items-center">
          <div className={styles.ResultsGroup}>
            <span className={styles.ResultsLabel}>
              {filters.favs_only === '1' && user?.id ? 'Your Favourites' : 'Results'}:
            </span>
            <div className={styles.CountContainer}>
              <span className={styles.CountDivider}>
                /{' '}
                <ResultCount
                  setResultCount={setResultCount}
                  additionalFilters={additionalFilters}
                />
              </span>
              {resultCount ? (
                <span className={styles.CountText}>
                  {resultCount === 1 ? 'Item' : 'Items'}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        <div className={styles.Controls}>
          <ProductViewSwitcher />
          {!isMobile ? <SortByFilter /> : null}
        </div>
      </div>
      <ActiveFilterItems />
    </div>
  );
};

export default ProductToolbar;
